// The school's own name on the candidate pages (exam, interview, completed).
// Read once per page load from GET /public/school — the school is the one the
// address belongs to. Until it answers (or if it cannot), a neutral
// "Delhi Public School" / "DPS" stands, never another school's name.
import { useEffect, useState } from "react";
import api from "../../services/api";

const FALLBACK = { schoolName: "Delhi Public School", shortName: "DPS", examGuideUrl: "" };
let pending = null;

function load() {
  if (!pending) {
    pending = api.get("/public/school")
      .then((r) => {
        const d = r.data?.data || {};
        return {
          schoolName: d.schoolName || FALLBACK.schoolName,
          shortName: d.shortName || (d.schoolName ? d.schoolName.replace(/^Delhi Public School\b/, "DPS") : FALLBACK.shortName),
          // The school's "how the online exam works" video, if it set one.
          examGuideUrl: /^https:\/\//i.test(d.examGuideUrl || "") ? d.examGuideUrl : "",
        };
      })
      .catch(() => { pending = null; return FALLBACK; });
  }
  return pending;
}

export default function useSchoolName() {
  const [school, setSchool] = useState(FALLBACK);
  useEffect(() => {
    let live = true;
    load().then((s) => { if (live) setSchool(s); });
    return () => { live = false; };
  }, []);
  return school;
}
